import React from 'react';
import { tilesFor, TILE_SIZE } from '../lib/tiles';

/**
 * Kartbild av var träffen är, som visuellt element överst på kortet.
 *
 * Bilden säger något om platsen i stället för att bara fylla ut, och den
 * kostar inget extra beroende — det är samma kartrutor som kartan använder.
 */
// Rutorna raknas ut for den har referensbredden och placeras sedan i
// cqw — hundradelar av kortets bredd — sa att hela lagret skalar ihop
// oavsett hur brett kortet faktiskt blir.
// Halls avsiktligt liten: varje ruta ar ett anrop mot OpenStreetMap, och
// en lista med tio traffar ska inte kosta atta rutor styck. CSS:en skalar
// upp lagret till kortets bredd.
const WIDTH = 512;
const HEIGHT = 208;

export default function MeetThumbnail({ lat, lng, children }) {
  const tiles = tilesFor({
    lat: Number(lat),
    lng: Number(lng),
    zoom: 15,
    width: WIDTH,
    height: HEIGHT,
  });

  return (
    <div className="meet-thumb">
      <div className="meet-thumb__tiles" aria-hidden="true">
        {tiles.map(tile => (
          <img
            key={tile.key}
            src={tile.url}
            alt=""
            loading="lazy"
            width={TILE_SIZE}
            height={TILE_SIZE}
            style={{
              left: `${(tile.left / WIDTH) * 100}cqw`,
              top: `${(tile.top / WIDTH) * 100}cqw`,
            }}
          />
        ))}
      </div>

      <span className="meet-thumb__pin" aria-hidden="true" />
      <div className="meet-thumb__overlay">{children}</div>
    </div>
  );
}
